export const KEYWORDS = [
	{
		text: 'K',
		color: 'text-bittersweet',
	},
	{
		text: 'A',
		color: 'text-bittersweet',
	},
	{
		text: 'I',
		color: 'text-bittersweet',
	},
	{
		text: 'Z',
		color: 'text-bittersweet',
	},
	{
		text: 'E',
		color: 'text-bittersweet',
	},
	{
		text: 'N',
		color: 'text-bittersweet',
	},
];

export const DESCRIPTION = [
	{
		hightLight: 'Key Learning Segments',
		text: 'Chương trình học được chia thành các mục tiêu học tập hàng ngày, linh hoạt và dễ dàng điều chỉnh để phù hợp với tiến độ học tập và năng lực của từng học viên.',
	},
	{
		hightLight: 'Assessment for Growth',
		text: `Đánh giá liên tục là công cụ giúp giáo viên và học viên theo dõi tiến độ, kịp thời phát hiện các "lỗ hổng" và cải thiện những phần chú trọng trong quá trình học.`,
	},
	{
		hightLight: 'In-Depth Guidance',
		text: 'Mô hình học tập 1 học viên - 3 giáo viên, bao gồm giảng viên chính, giáo viên kèm riêng và cố vấn học tập, đảm bảo sự hướng dẫn chi tiết và liên tục, giúp học viên không bị bỏ lại phía sau.',
	},
	{
		hightLight: 'Zero-Barrier Learning',
		text: 'Nền tảng học tập trực tuyến được phát triển độc quyền cho học viên DLA, hỗ trợ quá trình học tập và tự luyện tập, tăng thời lượng tương tác với tiếng Anh.',
	},
	{
		hightLight: 'Experiential Learning Journey',
		text: 'DLA cung cấp phòng tự học, phòng thư giãn, tổ chức các chuyến field trips và workshops định hướng, tạo điều kiện cho học viên trải nghiệm hành trình luyện thi IELTS/PTE hiệu quả nhất.',
	},
	{
		hightLight: 'Nurturing Pathways',
		text: 'Học viên và giáo viên cùng thảo luận và thiết lập mục tiêu, nhận diện điểm mạnh cũng như điểm cần cải thiện, từ đó xây dựng lộ trình học tập cá nhân hóa, phù hợp với từng nhu cầu riêng biệt.',
	},
];
